// ─── Storage Event Dispatcher (Firefox-compatible) ──────────────────────────
// Patches localStorage via Object.defineProperty on the prototype and a Proxy
// wrapper so it works in Firefox, Safari, and all other browsers.

const originalSetItem = Storage.prototype.setItem
const originalRemoveItem = Storage.prototype.removeItem
const originalClear = Storage.prototype.clear

function dispatchStorageEvent(
  key: string | null,
  oldValue: string | null,
  newValue: string | null,
  storageArea: Storage
): void {
  if (typeof StorageEvent === 'function') {
    const event = new StorageEvent('storage', {
      key,
      oldValue,
      newValue,
      url: window.location.href,
      storageArea,
    })
    window.dispatchEvent(event)
  }
}

// Patch the prototype so ALL Storage instances (localStorage, sessionStorage)
// get the patched behavior. This is the key to Firefox compatibility.
Object.defineProperty(Storage.prototype, 'setItem', {
  value: function (key: string, value: string): void {
    const oldValue = this.getItem(key)
    originalSetItem.call(this, key, value)
    dispatchStorageEvent(key, oldValue, value, this)
  },
  writable: true,
  configurable: true,
})

Object.defineProperty(Storage.prototype, 'removeItem', {
  value: function (key: string): void {
    const oldValue = this.getItem(key)
    originalRemoveItem.call(this, key)
    dispatchStorageEvent(key, oldValue, null, this)
  },
  writable: true,
  configurable: true,
})

Object.defineProperty(Storage.prototype, 'clear', {
  value: function (): void {
    const oldEntries = Object.keys(this).map((key) => [key, this.getItem(key)] as const)
    originalClear.call(this)
    oldEntries.forEach(([key, oldValue]) => {
      dispatchStorageEvent(key, oldValue, null, this)
    })
  },
  writable: true,
  configurable: true,
})